import { QUIZ_API } from '../Constants';

/**
 * Fetch a set of questions by slug
 *
 * @param {string} slug The unique slug of the set
 * @return {object[]} questions.
 */
export async function fetchQuestionsFromAPI(slug) {
  const apiURL = `${QUIZ_API}/${slug}`;

  return fetch(apiURL)
      .then((response) => {
        if (response.status >= 400) {
          throw (response);
        }
        return response;
      })
      .then((response) => response.json());
}

/**
 * Fetch a set of questions by slug
 *
 * @param {string} slug The unique slug of the set
 * @param {object} answers The answers object
 * @return {object[]} questions.
 */
 export function postAnswersToAPI(slug, answers) {
  const apiURL = `${QUIZ_API}/${slug}`;

  return fetch(apiURL, {
    method: 'POST', // or 'PUT'
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(answers),
  })
      .then((response) => {
        if (response.status >= 400) {
          throw (response);
        }
        return response;
      })
      .then((response) => response.json());
}

/**
 * Check whether the selected answers are correct/
 *
 * @param {array} selectedAnswers - The selected answers
 */
export async function checkAnswers(selectedAnswers) {
  try {
      const response = await postAnswersToAPI('result', selectedAnswers )
      return response;
  } catch (e){
    // eslint-disable-next-line no-console
    console.log(e);
    return false;
  }
}

/**
 * @param {Object} answers - The selected answers
 * @param {String} slug - The quiz slug
 * @param {String} language - The language code (e.g., 'en', 'nl')
 * @param {Object} userData - User data from Okta (email, oktaorgname, companyname, organization)
 * @param {Array} feedbackResponses - Optional feedback responses from feedback questions
 */
export async function saveScoreInDatabase(answers, slug, language, userData = {}, feedbackResponses = []) {
  const quizAnswers = await checkAnswers(answers);

  const nowDate = new Date();
  const date = nowDate.toLocaleString("nl-nl", {day: 'numeric', month: 'numeric', year: 'numeric'});
  const timestamp = nowDate.toLocaleString("nl-nl", {hour: '2-digit', minute: '2-digit', second: "2-digit"});
  const timestampString = nowDate.toTimeString();

  if (quizAnswers) {
    const apiURL = `${QUIZ_API}/${slug}/save`;
    
    try {
      const response = await fetch(apiURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          questionsTotal: quizAnswers?.top,
          questionsCorrect: quizAnswers?.score,
          givenAnswers: answers,
          feedbackResponses: feedbackResponses,
          date: date,
          timestamp: timestamp,
          timestampString: timestampString,
          language: language,
          email: userData.email,
          oktaorgname: userData.oktaorgname,
          companyname: userData.companyname,
          organization: userData.organization,
          selectedCompany: userData.selectedCompany,
        }),
      });
      
      if (response.status >= 400) {
        throw new Error('Failed to save quiz results');
      }
      
      return await response.json();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      return false;
    }
  }
}

/**
 * @param {string} email
 * @param {string} slug 
 */
export async function checkQuizSubmitted(email, slug) {
  let alreadySubmitted = false;

  if (email) {
    const apiURL = `${QUIZ_API}/${slug}/check?email=${encodeURIComponent(email)}`;
    
    try {
      const response = await fetch(apiURL);
      
      if (response.status >= 400) {
        throw new Error('Failed to check quiz submission');
      }
      
      const data = await response.json();
      alreadySubmitted = data?.submitted || false;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }

  return alreadySubmitted;
}
